import { render, staticRenderFns } from "./WorkCategories.vue?vue&type=template&id=583c8423&scoped=true"
import script from "./WorkCategories.vue?vue&type=script&lang=js"
export * from "./WorkCategories.vue?vue&type=script&lang=js"
import style0 from "./WorkCategories.vue?vue&type=style&index=0&id=583c8423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c8423",
  null
  
)

export default component.exports